var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFamilygroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 3.5C15 4.74553 14.3461 5.84113 13.3636 6.46158C14.3461 6.99345 15 7.93258 15 9C15 9.552 14.553 10 14 10H9C8.447 10 8 9.552 8 9C8 7.93258 8.65388 6.99345 9.63641 6.46158C8.65388 5.84113 8 4.74553 8 3.5C8 1.57 9.57 0 11.5 0C13.43 0 15 1.57 15 3.5ZM7 15.5C7 16.7455 6.34612 17.8411 5.36359 18.4616C6.34612 18.9935 7 19.9326 7 21C7 21.553 6.553 22 6 22H1C0.447 22 0 21.553 0 21C0 19.9326 0.653876 18.9935 1.63641 18.4616C0.653877 17.8411 0 16.7455 0 15.5C0 13.57 1.57 12 3.5 12C5.43 12 7 13.57 7 15.5ZM14 22C14.553 22 15 21.553 15 21C15 19.9326 14.3461 18.9934 13.3636 18.4616C14.3461 17.8411 15 16.7455 15 15.5C15 13.57 13.43 12 11.5 12C9.57 12 8 13.57 8 15.5C8 16.7455 8.65388 17.8411 9.63641 18.4616C8.65388 18.9934 8 19.9326 8 21C8 21.553 8.447 22 9 22H14ZM22 22C22.553 22 23 21.553 23 21C23 19.9326 22.3461 18.9934 21.3636 18.4616C22.3461 17.8411 23 16.7455 23 15.5C23 13.57 21.43 12 19.5 12C17.57 12 16 13.57 16 15.5C16 16.7455 16.6539 17.8411 17.6364 18.4616C16.6539 18.9934 16 19.9326 16 21C16 21.553 16.447 22 17 22H22ZM3 10C2.447 10 2 9.552 2 9V5C2 4.448 2.447 4 3 4H6C6.553 4 7 4.448 7 5C7 5.552 6.553 6 6 6H4V9C4 9.552 3.553 10 3 10ZM19 9C19 9.552 19.447 10 20 10C20.553 10 21 9.552 21 9V5C21 4.448 20.553 4 20 4H17C16.447 4 16 4.448 16 5C16 5.552 16.447 6 17 6H19V9Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilygroup);
export default __webpack_public_path__ + "static/media/family group.b17974dc0d8d96b49e20c11e41db305f.svg";
export { ForwardRef as ReactComponent };